import { Checkbox } from "@ucloud-fe/react-components";
import React from "react";
import urls from "../../config/urls";
import localeService from "../../service/localeService";

class TcCheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.query = props.location.query;
    if (this.query["privacy_statement"]) {
      this.privacyStatement = true;
    }
  }

  render() {
    const {
      checked,
      onChange,
      notSingaporeChecked,
      notSingaporeChange,
      isShowNotSingaporeCheck,
      style = {},
    } = this.props;
    return (
      <div style={{ ...style }}>
        <div className="register-tc-wrapper style-links">
          <Checkbox
            onChange={onChange}
            className="register-tc-checkbox u-vm"
            checked={checked}
            style={{ marginRight: "8px", lineHeight: "23px" }}
          />
          {!this.privacyStatement ? (
            <span className="register-agree">
              <span className="u-vm normal-text">
                {localeService.getTranslate("LOGIN19")}
              </span>
              <span className="normal-text">
                <a
                  className="u-vm u-blue u-ml4"
                  href={urls.URL001}
                  target="_blank"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(urls.URL001);
                  }}
                >
                  {localeService.getTranslate("REGISTER_WORD")}
                </a>
              </span>
            </span>
          ) : (
            <span>
              <span className="u-vm normal-text">
                I hereby agree to the &lt;
              </span>
              <a
                className="u-vm uc-link--underline u-blue"
                target="_blank"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(urls.URL007);
                }}
                href={urls.URL007}
              >
                UCloud US Website Membership Agreement
              </a>
              <span>&gt;, &lt;</span>
              <a
                className="u-vm uc-link--underline u-blue"
                target="_blank"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(urls.URL008);
                }}
                href={urls.URL008}
              >
                UCloud Privacy Policy
              </a>
              <span className="u-vm normal-text">
                &gt;, under which I am contracting with UCloud US LLC.
              </span>
            </span>
          )}
        </div>
        {/* 只128渠道增加该声明 */}
        {APP_CONFIG.isNotSingapore && isShowNotSingaporeCheck && (
          <div className="style-links" style={{ fontSize: "12px" }}>
            <Checkbox
              onChange={notSingaporeChange}
              className="register-tc-checkbox u-vm"
              checked={notSingaporeChecked}
              style={{ marginRight: "8px", lineHeight: "23px" }}
            />
            <span className="u-vm normal-text">
              {localeService.getTranslate("REGISTER_128N")}
            </span>
          </div>
        )}
      </div>
    );
  }
}

export default TcCheckBox;



// WEBPACK FOOTER //
// src/pc/components/TcCheckBox.jsx